import { FC } from "react";
import { get } from "lodash";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useDeleteNewsMeta } from "./hooks/useDeleteNewsMeta";
import { useModalHandler } from "hooks/useModalHandler";
import { ConfirmationModal } from "common/ConfirmationModal";
import { Edit } from "common/AllPages/actions/edit";
import { Delete } from "common/AllPages/actions/delete";

export interface NewsMetaCardProps {
  newsMetaData: any;
  newsMeta: [];
  setNewsMeta: any;
}

export const NewsMetaCard: FC<NewsMetaCardProps> = ({
  newsMetaData,
  newsMeta,
  setNewsMeta,
}) => {
  const [isOpen, openModal, closeModal] = useModalHandler();
  const deleteNewsMeta = useDeleteNewsMeta();
  const newsMetaId = get(newsMetaData, "id", "");

  return (
    <ListItem>
      <Box>
        <Typography variant="body2" color="text.primary">
          <b>Page meta tags</b>
        </Typography>
      </Box>
      <Box sx={{ ml: "auto" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Edit pageId={newsMetaId} pathToEdit="meta/news" />
          {/* @ts-ignore */}
          <Delete clickHandler={openModal} />
        </Box>
      </Box>
      {isOpen && (
        <ConfirmationModal
          // @ts-ignore
          isModalOpen={isOpen}
          // @ts-ignore
          closeModal={closeModal}
          confirmHandler={() => {
            deleteNewsMeta(newsMetaId, newsMeta, setNewsMeta);
            // @ts-ignore
            closeModal();
          }}
          message={`Are you sure you want to remove the news page meta tags?`}
        />
      )}
    </ListItem>
  );
};
